<div>
  <ng-container *ngFor="let button of buttons">
    <a *ngIf="button !== 'separator'" tabindex="0" class="fate-ui-button" [name]="button" [ngClass]="{enabled: enabled[button], 'with-dropdown': dropdownAction === button}" (click)="do($event, button)">
      <span *ngIf="icon.getIcon(button)" [innerHtml]="icon.getIcon(button)"></span>
      <span *ngIf="!icon.getIcon(button)">{{controller.getAction(button).label}}</span>
      <span class="reader">{{controller.getAction(button).name}}</span>
    </a>
    <div *ngIf="button === 'separator'" class="fate-ui-separator"></div>
  </ng-container>
  <div class="fate-ui-dropdown" [ngClass]="{visible: dropdownAction}">
    <ng-template #dropdown></ng-template>
  </div>
</div>
